import React, { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, SxProps, Theme, Typography } from '@mui/material';

import { useSceneMenuContext } from './context';

export function SceneMenuReplacement({
  id,
  sx,
  title,
  minWidth,
  children,
}: PropsWithChildren<{ id: string; sx?: SxProps<Theme>; minWidth: string; title?: string }>) {
  const { activeReplacement, containerEl, deactivateReplacement } = useSceneMenuContext();

  if (activeReplacement === id && containerEl) {
    return createPortal(
      <Box sx={[{ minWidth }, ...(Array.isArray(sx) ? sx : [sx])]}>
        <Typography
          variant="h5"
          sx={{ marginLeft: 1, display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}
          gutterBottom
        >
          <IconButton onClick={deactivateReplacement}>
            <ArrowBackIcon />
          </IconButton>

          {title && <span style={{ marginLeft: '8px' }}>{title}</span>}
        </Typography>

        {children}
      </Box>,
      containerEl,
    );
  }

  return <span />;
}
